<main id="main" class="main">
  <div class="row">
    <div class="col-12 col-md-12 d-flex justify-content-between" style="background: #5d7c9b!important; font-size:14px">
      <h6 class="admintitle my-auto">
        System Users&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
      </h6>
      <button class="addCustomer my-auto">+&nbsp;Add New</button>


    </div>
  </div>
  <div class="row">
    <img src="../../../assets//img/Manage System Users.png">
  </div>

</main>